import React from 'react'

import {
    MinusOutlined,
    ReloadOutlined,
    ExportOutlined,
    ImportOutlined,
    CloseOutlined,
  } from "@ant-design/icons";

import Logo from "../Images/logo.png";
import apiService from '../Services/apiServices';
function Header(props) {

    const {showMinimizedChat, setShowMinimizedChat,showMaximumChat ,setIsShowMaximumChat ,handleClose ,clearMessages ,setShowMsgs ,startLogin ,setFinalTimerFlag ,setCheckThumsDownFeedback} = props
  return (
    
      <div style={{height : showMaximumChat && '7vh'}} className="bot-header">
        <div className="bot-logo">
          <img src={Logo} alt="logo"></img>
        </div>
        <div className="bot-head-action-items">
          {!showMinimizedChat && (
            <ReloadOutlined className="bot-head-action-icon" onClick={() => {
              clearMessages()
              setShowMsgs(false)
              apiService.loginForRefresh('6')
              startLogin()
              setCheckThumsDownFeedback([])
          }}/>
          )}

          {!showMaximumChat  && !showMinimizedChat && (
            <MinusOutlined
              className="bot-head-action-icon"
                  onClick={() => setShowMinimizedChat(true)}
            />
          )}
          {!showMaximumChat && (
            <ExportOutlined
              className="bot-head-action-icon"
              onClick={() => {   showMinimizedChat ?  setShowMinimizedChat(false)  : setIsShowMaximumChat(!showMaximumChat) }}                              
            />
          )}
          {showMaximumChat && (
            <ImportOutlined
              onClick={() => setIsShowMaximumChat(!showMaximumChat)}
            />
          )}

          <CloseOutlined
            className="bot-head-action-icon"
            onClick={() => handleClose()}
          />
        </div>
      </div>
  )
}

export default Header
